import axios from 'axios'
import constants from '@/assets/js/constants.js'

const state = {
    transferPurposes: [],
    documentCategories: []
};

const getters = {
    allDocumentCategories: state => state.documentCategories
};

let loadedTransferPurposes = [];

export const getTransferPurposes = () => loadedTransferPurposes.map(purpose => ({ ...purpose }));

const actions = {
    async fetchTransferPurposes({ commit })
    {
        await axios.get(constants.baseApiUrl + 'Lookups/get-all-purposes')
            .then(res => commit('setTransferPurposes', res.data))
            .catch(err => console.log('from lookups.js, error is ' + err));

        return loadedTransferPurposes;
    },
    async fetchDocumentCategories({ commit }, callbackFunction)
    {
        await axios.get(constants.baseApiUrl + 'Lookups/get-all-Categories')
            .then(res =>
            {
                commit('setDocumentCategories', res.data);

                if (callbackFunction != null)
                    callbackFunction()
            })
            .catch(err => console.log('from lookups.js, error is ' + err));
    },
};

const mutations = {
    setTransferPurposes: (state, transferPurposes) =>
    {
        state.transferPurposes = transferPurposes;
        loadedTransferPurposes = transferPurposes || [];
    },
    setDocumentCategories: (state, documentCategories) => (state.documentCategories = documentCategories)
};

export default {
    state,
    getters,
    actions,
    mutations
};
